import { EnvMicroIntegration } from "lib-klab-core";

export const envIntegrationLocal: EnvMicroIntegration = {
  host: "",
  apiBasePath: "/ms-integration",
  enabled: true,
};

export const envIntegrationDev: EnvMicroIntegration = {
  host: "https://gatewayapi-dev.erp.inclub.world",
  apiBasePath: "/ms-integration",
  enabled: true,
};

export const envIntegrationProd: EnvMicroIntegration = {
  host: "",
  apiBasePath: "/ms-integration",
  enabled: false,
};
